import { VBox } from "@ui/box/Box";
import { TFormButton, createName } from "src/view/FormParser";
import { GD } from "src/GD";
import { KycCallout } from "./ProviderKycStatus";
import { DependentFormParser, IFieldDependency } from "./DependentFormParser";

interface ICardHolderFormProps {
	onRequest: () => Promise<any>;
	onSubmit: (data: any) => Promise<any>;
	primaryButton?: TFormButton | null;
	secondaryButton?: TFormButton | null;
	/** Wasabi 2201: server-reported fields that must be filled before retrying. */
	missingFields?: string[];
	issuer?: number;
}

// "address.city_code" -> "city_code" (decorate() flattens address onto the root).
const normalizeFieldPath = (field: string): string => {
	const parts = field.split(".");
	return parts[parts.length - 1];
};

export const CardHolderForm = ({ onRequest, onSubmit, primaryButton, secondaryButton, missingFields, issuer }: ICardHolderFormProps) => {
	const missing = (missingFields ?? []).map(normalizeFieldPath);
	const cityDependencies: IFieldDependency[] = Number.isInteger(issuer) && Number(issuer) > 0 ? [{
		field: "address.city_code",
		dependsOn: "address.country_code",
		resolve: async countryCode => {
			const response = await GD.REQ_COMMON_CITIES.request({ countryCode: String(countryCode), issuer: Number(issuer) });
			if (response.error) throw response.error;
			return response.data.map(city => ({ name: city.name, value: city.code }));
		},
	}] : [];

	return (
		<VBox gap="16px">
			{missing.length > 0 && (
				<KycCallout tone="pending" title="Complete card holder details">
					The card provider requires these fields before the card can be issued: <b>{missing.map((f) => createName(f)).join(", ")}</b>
				</KycCallout>
			)}
			<DependentFormParser
				onRequest={onRequest}
				onSubmit={onSubmit}
				dependencies={cityDependencies}
				highlightedFields={missing}
				fullSizeButtons
				primaryButton={primaryButton ? { ...primaryButton, sx: { whiteSpace: "normal", lineHeight: 1.2, textAlign: "center", ...primaryButton.sx } } : primaryButton}
				secondaryButton={secondaryButton ? { ...secondaryButton, sx: { whiteSpace: "normal", lineHeight: 1.2, textAlign: "center", ...secondaryButton.sx } } : secondaryButton}
				actionsSx={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "#FFFFFF", paddingBottom: "4px" }}
			/>
		</VBox>
	);
};
